import { SvgIcon } from '@mui/material'

export function ArrowIcon(props) {
  return (
    <SvgIcon {...props}>
      <svg
        viewBox="0 0 16 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <clipPath id="clip0_10129_3891">
            <rect width="16" height="18" fill="white" />
          </clipPath>
        </defs>
        <g clipPath="url(#clip0_10129_3891)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16 9L0 0L7.73802 9L0 18L16 9Z"
            fill="currentColor"
          />
        </g>
      </svg>
    </SvgIcon>
  )
}

export const ArrowIconDown = () => <ArrowIcon sx={{ transform: 'rotate(90deg)' }} />
export const ArrowIconLeft = () => <ArrowIcon sx={{ transform: 'rotate(180deg)' }} />
export const ArrowIconUp = () => <ArrowIcon sx={{ transform: 'rotate(270deg)' }} />